import React from 'react'

import Attachment from "../../../../../model2/attachment/attachment"
import ControlButtonStandard from "../../../../buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../buttons/control-button/@types"

type Props = {
    className?      : string

    attachment      : Attachment

    onPreviewClick? : callback
}

export default function AttachmentButtonPreview(props: Props) {

    if (!props.attachment) return null

    const onClick = (e:any) => {
        e.stopPropagation()
        props.onPreviewClick?.(props.attachment)
    }

    return <ControlButtonStandard className = {props.className}
                                  size      = {ControlButtonSize.SIZE_28}
                                  iconClass = "i5-eye fs-12"
                                  onClick   = {onClick}/>
}
